import type { CreateSessionRequest, CreateSessionResponse } from './Type';
import { request } from '@/utils/Request';

export async function createSession(data: CreateSessionRequest) {
  const requestData: CreateSessionRequest = {
    ...data,
  };
  return request.post<CreateSessionResponse>("/api/session/create_session", requestData);
}